import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteCategory() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function deleteCategory(categoryID) {
    return privateFetch.delete(`/v1/admin/podcast/supporting/category/${categoryID}`);
  }

  return useMutation(deleteCategory, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries('podcast-category');
    },
  });
}

export default useDeleteCategory;
